import React, { useEffect, useRef } from 'react';
import NodeResolver from 'react-node-resolver';
/**
 * A wrapper component that conditionally applies a NodeResolver to its children.
 *
 * Note: NodeResolver should not be used in React 18 concurrent mode. This component
 * is intended to be removed once the feature flag  is removed.
 * @param {boolean} props.hasNodeResolver - Determines whether to apply the NodeResolver.
 * @param {ReactElement} props.children - The child elements to be wrapped.
 * @param {string} props.name - The name to reference from Spotlight.
 * @param {ReactElement} props.targetRef - Setting up Target Node in Spotlight Manager.
 * @returns {ReactElement} The children wrapped with NodeResolver if hasNodeResolver is true, wrape the children in a div setting innerRef with ref to the div.
 */
const NodeResolverSpotlightTarget = ({
  hasNodeResolver,
  children,
  targetRef,
  name
}) => {
  const divRef = useRef(null);
  useEffect(() => {
    if (!hasNodeResolver) {
      var _divRef$current;
      targetRef(name)((_divRef$current = divRef.current) === null || _divRef$current === void 0 ? void 0 : _divRef$current.firstElementChild);
    }
    return () => {
      !hasNodeResolver && targetRef(name)(undefined);
    };
  }, [hasNodeResolver, name, targetRef]);
  if (hasNodeResolver) {
    return /*#__PURE__*/React.createElement(NodeResolver, {
      innerRef: targetRef(name)
    }, children);
  }
  return /*#__PURE__*/React.createElement("span", {
    ref: divRef
  }, children);
};
export default NodeResolverSpotlightTarget;